module.exports = __webpack_public_path__ + "static/war-and-peace-9e1d685aa14597db388eeecab8d7ba1f.jpg";